module.exports = __webpack_public_path__ + "img/37.3bf7a9b1.jpg";